<template>
    <div></div>
</template>

<script>
    export default {
        name: "AppScreens",
        head() {
            return {
                title: 'Application screens | Fine Wine Trading App',
                meta: [
                    {
                        hid: 'description',
                        name: 'description',
                        content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                    },
                    {
                        hid: 'robots',
                        name: 'robots',
                        content: 'noindex'
                    }
                ]
            }
        },
        data() {
            return {
                screenName: ''
            }
        },
        mounted() {
            this.screenName = this.$route.query.screenName;

            if (this.screenName.split('___').length > 1) {
                if (this.screenName.split('___')[1] === 'Auth' || this.screenName.split('___')[1] === 'App') {
                    if (this.screenName.split('___')[2] === 'ChristmasGifts') {
                        this.$router.push(this.localePath({ path: '/christmas-gifts' }));
                    } else if (this.screenName.split('___')[2] === 'Invoices') {
                        this.$router.push(this.localePath({ path: '/my-account/invoices' }));
                    } else if (this.screenName.split('___')[2] === 'WineCollectionsTab') {
                        this.$router.push(this.localePath({ path: '/collections' }));
                    } else if (this.screenName.split('___')[2] === 'HomeTab') {
                        this.$router.push(this.localePath({ path: '/' }));
                    } else if (this.screenName.split('___')[2].indexOf('WineDetails') > -1) {
                        let wineId = this.screenName.split('___')[2].split('_')[1],
                            caseSizeId = this.screenName.split('___')[2].split('_')[2];

                        this.$router.push(this.localePath({ path: '/wine-details/' + wineId + '/' + caseSizeId}));
                    }
                } else {
                    if (this.screenName.split('___')[1] === 'ChristmasGifts') {
                        this.$router.push(this.localePath({ path: '/christmas-gifts' }));
                    } else if (this.screenName.split('___')[1] === 'Invoices') {
                        this.$router.push(this.localePath({ path: '/my-account/invoices' }));
                    } else if (this.screenName.split('___')[1] === 'WineCollectionsTab') {
                        this.$router.push(this.localePath({ path: '/collection-details/' + this.screenName.split('___')[2] }));
                    } else if (this.screenName.split('___')[1] === 'LiveMarketTab') {
                        if (this.screenName.split('___')[2].indexOf('WineDetails') > -1) {
                            let wineId = this.screenName.split('___')[2].split('_')[1],
                                caseSizeId = this.screenName.split('___')[2].split('_')[2];

                            this.$router.push(this.localePath({ path: '/wine-details/' + wineId + '/' + caseSizeId + "/wine"}));
                        } else if (this.screenName.split('___')[2].indexOf('MarketScreen') > -1) {
                            this.$router.push(this.localePath({ path: '/trading-desk/'}));
                        } else {
                            let filtersObj = {
                                "vintage": null,
                                "countryId": null,
                                "regionId": null,
                                "appellationId": null,
                                "producerId": this.screenName.split('___')[2].split('_')[1],
                                "wineId": null,
                                "ghostWineId": null,
                                "ghostProducerId": this.screenName.split('___')[2].split('_')[1],
                                "colorId": null,
                                "priceFrom": null,
                                "priceTo": null,
                                "isEnPrimeur":"",
                                "hasOffers": null,
                                "hasBids": null,
                                "isFavorites": null
                            }

                            localStorage.setItem('livemarketFiltersObj', JSON.stringify(filtersObj));
                            localStorage.setItem('livemarketWineType', "0");
                            this.$router.push(this.localePath({ path: '/trading-desk/'}));
                        }
                    }
                }
            } else {
                if (this.screenName === 'Login') {
                    this.$router.push(this.localePath({ path: '/login' }));
                }
            }
        }
    }
</script>

<style scoped>
    .basket-container {
        padding: 100px calc(3 * var(--gutter)) calc(1.2 * var(--gutter));
        height: calc(100% - 413px);
    }

    .thankyou-img {
        background: url('../assets/v_dark.svg') no-repeat center;
        background-size: contain;
        width: 300px;
        height: 250px;
        margin: 0 auto;
    }

    .thankyou-wrapper {
        text-align: center;
        padding-bottom: 100px;
    }

    .additional-info {
        max-width: 1024px;
        margin: 30px auto;
        font-weight: 300;
    }

    .thankyou-wrapper .btn-primary {
        margin: 48px 0 32px;
    }
</style>
